import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';
import DialogFobConnectionComponent from '../DialogConnectionComponents/DialogFobConnectionComponent';
import { loadingFobDataComponent, loadingRankComponentDataComponent } from '../../../LoadingData/LoadingDataComponents';
import { UpdateFob, UpdateFobName, UpdateFobRank } from '../../../UpdateData/UpdateCommunications';
import DialogFobFotoEditing from '../DialogFoto/DialogFobFotoEditing';
import ModalDeleteComponentSpecifically from '../../../Modal/ModalDeleteComponentSpecifically';
import { FOB, FOB_FLAG } from '../../../Constants/ConstantsOptics';
import { UpdateFobEtherComponents, UpdateFobKtvComponents, UpdateFobPonComponents, UpdateStatusComponents } from '../../../UpdateData/UpdateStatusComponent';

const FobCantonEditingDialog = ({ open, onClose, onClose2, content, user, groupedCoordinatesWithColorTypeAndWidth,
  wellData,fobLocationData,couplingLocationData,ponBoxLocationData,pillarData, cantonFobRefresh, setIsComponentСhangeCoorFob}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [textComment, setTextComment] = useState(content.description);
  const [statusChange, setStatusChange] = useState(false);
  const [openModalConnection, setOpenModalConnection] = useState(false);
  const [fobData, setFobData] = useState([]);
  const [fobId, setFobId] = useState("");
  const [rankComponentData, setRankComponentData] = useState([]);
  const [fobRankId, setFobRankId] = useState("");
  const [openModalFoto, setOpenModalFoto] = useState(false);
  const [openModalConnectionDelete, setOpenModalConnectionDelete] = useState(false);
  const [statusPon, setStatusPon] = useState(false); 
  const [statusKtv, setStatusKtv] = useState(false); 
  const [statusEther, setStatusEther] = useState(false); 


  const handleСhangeCoor= (event) => {
    handleCloseDialogs();
    setIsComponentСhangeCoorFob(true);
  }

  const openModalConnectionComponentsDelete = () => {
    setOpenModalConnectionDelete(true);
  }; 

  const openModalFotoFile = () => {
    setOpenModalFoto(true);
  }; 

  useEffect(() => {
    setStatusPon(content.pon === 1);
    setStatusKtv(content.ktv === 1);
    setStatusEther(content.ether === 1);
  }, [content.activity, content.pon, content.ktv, content.ether]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [fobData, rankComponentData] = await Promise.all([
          loadingFobDataComponent(),
          loadingRankComponentDataComponent(),
        ]);
        setFobData(fobData);
        setRankComponentData(rankComponentData);
      } catch (error) {
        // console.error("Error in fetchData:", error);
      }
    };
    fetchData();
  }, []);

  const deleteFob = () => {
      UpdateStatusComponents(FOB, content.id, showSnackbar, user, cantonFobRefresh, handleCloseDialogs );
  }; 
  
  const handleCloseDialogs = () => {
    onClose2();
    onClose();
  };

  const openModalConnectionComponents = () => {
    setOpenModalConnection(true);
  }; 

  const handleDescriptionChange = (event) => {
    const newText = event.target.value;
    setTextComment(newText);

    if (newText !== content.comment) {
        setStatusChange(true);
    } else {
        setStatusChange(false);
    }
 };
 
  const updateFob = () => {
    if (statusChange) {
      UpdateFob(content.id, textComment, showSnackbar,content.authorId, cantonFobRefresh);
    } else {
      showSnackbar('Нет нужды в записи, текст без изменений!', 'snackbarOk');
    }
  };

  const handleChangeFobSelect = (event) => {
    const selectedFob = event.target.value;
    if (selectedFob === "") {
      setFobId("");
    } else {
      const selectedFob2 = fobData.find(fob => 
        `${fob.id}` === selectedFob
      );
      if (selectedFob2) {
        setFobId(selectedFob2.id);
      }
    }
  };

  const updateFobName = () => {
  
    if (fobId === "") {
      showSnackbar('Нет нужды в записи, Fob без изменений!', 'snackbarOk');
    } else {
      UpdateFobName(content.id, fobId, showSnackbar,content.authorId, cantonFobRefresh );
    } 
  };

  const handleChangeFobRankSelect = (event) => {
    const selectedFobRank = event.target.value;
    if (selectedFobRank === "") {
      setFobRankId("");
    } else {
      const selectedFobRank2 = rankComponentData.find(fobRank => 
        `${fobRank.id}` === selectedFobRank
      );
      if (selectedFobRank2) {
        setFobRankId(selectedFobRank2.id);
      }
    }
  };

  const updateFobRank = () => {
  
    if (fobRankId === "") {
      showSnackbar('Нет нужды в записи, ранг без изменений!', 'snackbarOk');
    } else {
      UpdateFobRank(content.id, fobRankId, showSnackbar,content.authorId, cantonFobRefresh );
    } 
  };

  const handlePonCheckboxChange = () => {
    setStatusPon(!statusPon);   
    if(!statusPon){
      UpdateFobPonComponents(content.id, 1, showSnackbar, cantonFobRefresh, content.authorId);
    }else{
      UpdateFobPonComponents(content.id, 0, showSnackbar, cantonFobRefresh, content.authorId)
    }
    
  };

  const handleKtvCheckboxChange = () => {
    setStatusKtv(!statusKtv);   
    if(!statusKtv){
      UpdateFobKtvComponents(content.id, 1, showSnackbar, cantonFobRefresh, content.authorId);
    }else{
      UpdateFobKtvComponents(content.id, 0, showSnackbar, cantonFobRefresh, content.authorId)
    } 
  };

  const handleEtherCheckboxChange = () => {
    setStatusEther(!statusEther);   
    if(!statusEther){
      UpdateFobEtherComponents(content.id, 1, showSnackbar, cantonFobRefresh, content.authorId);
    }else{
      UpdateFobEtherComponents(content.id, 0, showSnackbar, cantonFobRefresh, content.authorId)
    }
  };

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
      {content.rankComponentId === 1 || content.rankComponentId === 2 ? (
           <img src='./fob.png' width='30' height='30' style={{ marginRight: "5px" }} />
            ) : (
            <img src='./fob_canton.png' width='30' height='30' style={{ marginRight: "5px" }} />
          )}
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #3d3d3d'}}>Редактирование фоба</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #3d3d3d' }}>{content.id}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Город: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.city} </span> </label>
      <br/>
              <label style={{ color: '#292929', fontWeight: 'bold' }}>
                Территория:{' '}
                <span
                  style={{
                    color: !content.canton ? '#de858e' : '#bebebe',
                    fontWeight: 'normal',
                    textShadow: '2px 2px 4px #000000ff',
                  }}
                >
                  {content.canton
                    ? content.region && content.area
                      ? `${content.canton} ${content.region} ${content.area}`
                      : content.canton
                    : 'нет'}
                </span>
              </label>  
              <hr className='horizontalLineDialog'/> 
      
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Фоб: </label>

      <select className="selectStyleDrawer" 

        onChange={(event) => {
          handleChangeFobSelect(event);
        }} >
        <option value="">{content.fobName}</option>
        {fobData.map(fob => (
          <option key={fob.id} value={fob.id}>{fob.name}</option>
        ))}
      </select>
      <button onClick={updateFobName} class='buttonIsSaveDialog2'>Сохранить</button>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>

      <label style={{ color: '#292929', fontWeight: 'bold'}}>Мax ранг линка: </label>

      <select className="selectStyleDrawer" 

        onChange={(event) => {
          handleChangeFobRankSelect(event);
        }} >
        <option value="">{content.rankComponentName}</option>
        {rankComponentData.map(rank => (
          <option key={rank.id} value={rank.id}>{rank.name}</option>
        ))}
      </select>
      <button onClick={updateFobRank} class='buttonIsSaveDialog2'>Сохранить</button>

      <hr className='horizontalLineDialog2'/>

      <label style={{ color: '#292929', fontWeight: 'bold'}}>Признак:</label>

<label style={{ color: '#292929', fontWeight: 'bold', marginLeft:'10px'}}>PON:</label>
    <input
      type="checkbox"
      checked={statusPon}
      onChange={handlePonCheckboxChange}
      style={{ marginLeft: '10px' }}
    />      

  <label style={{ color: '#292929', fontWeight: 'bold', marginLeft:'10px'}}>KTV:</label>
    <input
      type="checkbox"
      checked={statusKtv}
      onChange={handleKtvCheckboxChange}
      style={{ marginLeft: '10px' }}
    />      

  <label style={{ color: '#292929', fontWeight: 'bold', marginLeft:'10px'}}>Ethernet:</label>
    <input
      type="checkbox"
      checked={statusEther}
      onChange={handleEtherCheckboxChange}
      style={{ marginLeft: '10px' }}
    />      

      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий:</label>
       
        <textarea
          className='textAreaEditingModal'
          value={textComment} 
          onChange={handleDescriptionChange} 
        />

      <br/>
      <button onClick={updateFob} class='buttonIsSaveDialog2' style={{marginLeft:"0px"}}>Сохранить</button>

     
      <hr className='horizontalLineDialog'/>
      {content.nodeStatus != 1 && (
        <>
         <button  class='buttonIsCoupFobDialog' onClick={openModalConnectionComponents}> Закрепить фоб</button>
         <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />
         <button  class='buttonIsEditDialog' onClick={handleСhangeCoor}> Редактировать на карте</button>
         <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />
         <button class='buttonIsEditDialog' onClick={openModalConnectionComponentsDelete}>Удаление связей</button>
        </>
      )}  
    
      <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />
      <button  class='buttonIsEditDialog' onClick={openModalFotoFile}> Редактирование файлов</button>
      <hr className='horizontalLineDialog'/>

      <button 
          className="buttonIsDeleteModal" 
          onClick={deleteFob} 
          style={{ fontSize: "14px", width: "60px", padding: "2px" ,textShadow: '2px 2px 4px #3d3d3d'}}
        >
          Удалить
        </button>

        <span 
          style={{
            marginLeft: "5px",
            fontSize: "12px",
            color: "#bebebe",
            textShadow: "0 0 5px rgba(0, 0, 0, 0.8)",  
          }}
        >
        Возможность восстановления 24 ч.
      </span>

      <hr className='horizontalLineDialog'/>

      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>

        <ModalDeleteComponentSpecifically
          open={openModalConnectionDelete}
          onClose={() => setOpenModalConnectionDelete(false)}
          id={content.id}
          type={FOB}
          flag={FOB_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        />

       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

        {/* Modal Foto*/}
        <DialogFobFotoEditing
          open={openModalFoto}
          onClose={() => setOpenModalFoto(false)}
          id={content.id}
          user={content.authorId}     
      />   

      <DialogFobConnectionComponent
          id={content.id}
          open={openModalConnection}
          onClose={() => setOpenModalConnection(false)}
          user={user}
      />
    </Dialog>
  );
}

export default FobCantonEditingDialog;